import { Button, Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress } from '@mui/material';
import { Box } from '@mui/system';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeDialog, openDialog } from '../../../features/dialog';
import { enqueueErrorSnack, enqueueSuccessSnack } from '../../../features/snackbar';
import { editJob, previewJob } from '../../../features/job';
import JobForm from '../JobForm';
import JobPreviewDialog from './JobPreviewDialog';
import { validateProjectJob } from '../../../validator/project';
import { hasErrors } from '../../../common';

const DIALOG_ID = "editJob"
const DIALOG_WIDTH = "md"

function EditJobDialog() {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const jobs = useSelector(state => {
        return [...state.job.all || [], ...state.job.list || []];
    });
    const jobId = useSelector((state) => state.dialog[DIALOG_ID])
    const show = !!jobId;
    const job = jobId ? jobs.find(j => j.id === jobId) : null;
    const [errors] = useState({});
    const [form, setForm] = useState({});

    const preview = e => {
        e && e.preventDefault() && e.stopPropagation();
        dispatch(previewJob(form))
        .then(() => {
            dispatch(openDialog("jobPreview"));
        })
        .catch(err => {
            dispatch(enqueueErrorSnack("Error previewing job: " + err.message));
        });
    }

    const save = e => {
        e && e.preventDefault() && e.stopPropagation();
        const errors = validateProjectJob(form);
        if(hasErrors(errors)){
            return;
        }

        const payload = {...form};
        if(payload.type === 'nfo'){
            const opts = payload.options && typeof payload.options === 'object' ? {...payload.options} : {};
            if(Array.isArray(opts.language_codes) && opts.language_codes.length === 0){
                delete opts.language_codes;
            }
            payload.options = opts;
        }

        setLoading(true);
        dispatch(editJob(payload))
        .then(r => {
            dispatch(closeDialog(DIALOG_ID));
            dispatch(enqueueSuccessSnack("Job saved"))    
        })
        .catch(e => {
            dispatch(enqueueErrorSnack("Error: " + e))    
        })
        .finally(() => {
            setLoading(false);
        })
    }

    const onClose = () => {
        dispatch(closeDialog(DIALOG_ID));
    }

    const canPreview = () => {
        if (!form?.type) return false;
        
        // For web search types, check for 'search' property
        if (form.type === 'wh') {
            return !!form.search;
        }
        
        // For other types, check for 'searchJson' property
        return !!form.searchJson && Object.keys(form.searchJson).length > 0;
    }
    

    useEffect(() => {
        setForm(job);
    }, [job, jobId]);

    // useEffect(() => {
    //     if(!jobs){
    //         if(project){
    //             dispatch(allJobs());
    //         }else{

    //         }
    //     }
    // }, [])
    
    return <>
        <JobPreviewDialog />
        <Dialog
            open={!!show}
            onClose={onClose}
            fullWidth
            maxWidth={DIALOG_WIDTH}
        >
        <form onSubmit={save}>
            <DialogTitle>
                Edit job
            </DialogTitle>
            <DialogContent dividers={false}>
                <Box pr={3}>
                    <JobForm form={form || job} onChange={setForm} errors={errors} />
                </Box>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'space-between', px: 3, pb: 2 }}>
                {loading && <LinearProgress sx={{ position: 'absolute', top: 0, left: 0, right: 0 }} />}
                <Button onClick={onClose} disabled={loading}>Cancel</Button>
                <Box sx={{ display: 'flex', gap: 1 }}>
                    <Button id="previewButton" variant="contained" color="secondary" disabled={!canPreview() || loading} onClick={preview}>
                        Preview Job
                    </Button>
                    <Button variant="contained" color="secondary" type="submit" disabled={loading}>
                        Save Job
                    </Button>
                </Box>
            </DialogActions>
        </form>
    </Dialog>
    </>
}

export default EditJobDialog;